"use strict";

var _LauncherProvider;
import { LauncherProvider } from './HomeLauncherVehicleProvider';
import { HomeQuoteLauncher } from './HomeQuoteLauncher';
import { jsx as _jsx } from "react/jsx-runtime";
export const HomeComponent = () => _LauncherProvider || (_LauncherProvider = /*#__PURE__*/_jsx(LauncherProvider, {
  children: /*#__PURE__*/_jsx(HomeQuoteLauncher, {})
}));